<div
  infinite-scroll
  class="user-list-wrapper"
  [scrollWindow]="false"
  [infiniteScrollUpDistance]="3"
  (scrolled)="onScroll()"
  (scrolledUp)="onScrollUp()">
  <ul style="position: relative">
    <li class="mb-2 pt-2 pb-2" style="position: sticky; top: 0; background-color: white">
      <div [hidden]="!loading" class="text-center">
        <i class="fas fa-spin fa-spinner"></i>
        <span class="ms-2">{{ '::Loading' | abpLocalization }}...</span>
      </div>
      <div *ngIf="departmentBased && !departmentId" class="text-center">
        <i class="fa-regular fa-circle-info"></i>
        <span class="ms-2">{{ 'AbpUi::PleaseSelectDepartment' | abpLocalization }}...</span>
      </div>
      <div
        *ngIf="items.length === 0 && !loading && !(departmentBased && !departmentId)"
        class="text-center">
        <i class="fa-regular fa-circle-info"></i>
        <span class="ms-2">{{ 'AbpUi::NoResults' | abpLocalization }}.</span>
      </div>
      <div
        [ngClass]="loading || items.length === 0 ? 'd-none' : 'd-flex'"
        class="flex-row justify-content-stretch aling-items-center">
        <div>
          <input
            #chkAll
            [hidden]="loadingForSelectingAll"
            type="checkbox"
            class="form-check-input"
            id="chkAll"
            (change)="onSelectAllChange($event)" />
          <i *ngIf="loadingForSelectingAll" class="fas fa-spin fa-spinner"></i>
        </div>
        <div class="flex-grow-1 flex-shrink-1 ms-2">
          <label for="chkAll">{{ 'AbpUi::SelectAll' | abpLocalization }} ({{ totalCount }})</label>
        </div>
      </div>
    </li>
    <li *ngFor="let item of items" class="mb-2">
      <div class="d-flex flex-row justify-content-stretch align-items-center">
        <div>
          <input
            type="checkbox"
            class="form-check-input"
            [attr.id]="'chk-' + item.id"
            [checked]="isUserSelected(item)"
            (change)="onUserSelectionChange(item, $event)" />
        </div>
        <div class="ms-2 mt-1 user-photo-wrapper">
          <ca-user-photo
            *ngIf="userProfileThumbnailsCached"
            [useCurrentUser]="false"
            [userId]="item.id"
            [nameAndSurname]="[item.name, item.surname]"
            [classes]="['user-avatar']"></ca-user-photo>
        </div>
        <div class="flex-grow-1 flex-shrink-1">
          <label [attr.for]="'chk-' + item.id" class="ca-agent-identity">
            <span class="fullname">{{ item.fullname }}</span>
            <span *ngIf="item.username" class="username">@{{ item.username }}</span>
          </label>
        </div>
      </div>
    </li>
  </ul>
</div>
